import apiClient from '../utils/api';
import axios from 'axios';

export interface GenerateUploadUrlData {
  vendorId: string;
  productId?: string;
  fileType: string;
}

export interface GenerateUploadUrlResponse {
  success: boolean;
  uploadUrl: string;
  imageUrl: string;
  key: string;
}

export interface ConfirmUploadData {
  vendorId: string;
  imageUrl: string;
}

export interface ConfirmUploadResponse {
  success: boolean;
  message: string;
}

export const vendorImageService = {
  /**
   * Generate pre-signed S3 upload URL
   */
  generateUploadUrl: async (
    data: GenerateUploadUrlData
  ): Promise<GenerateUploadUrlResponse> => {
    const response = await apiClient.post<GenerateUploadUrlResponse>(
      `/vendors/${data.vendorId}/generate-upload-url`,
      data
    );
    return response.data;
  },

  /**
   * Upload image directly to S3 using pre-signed URL
   */
  uploadToS3: async (uploadUrl: string, file: File): Promise<void> => {
    // Upload directly to S3 (not through our API)
    await axios.put(uploadUrl, file, {
      headers: {
        'Content-Type': file.type,
      },
    });
  },

  /**
   * Confirm upload and save image URL to vendor profile
   */
  confirmUpload: async (
    data: ConfirmUploadData
  ): Promise<ConfirmUploadResponse> => {
    const response = await apiClient.post<ConfirmUploadResponse>(
      `/vendors/${data.vendorId}/confirm-upload`,
      data
    );
    return response.data;
  },
};

